import React, { useEffect, useRef } from "react"
import styles from "./index.module.scss"
import lottie from 'lottie-web'

interface IProps {
  loadingText?: string
}

const LoadingMore = (props: IProps) => {
  const lottieNode = useRef<any>(null)

  useEffect(() => {
    showLottie()
    return componentWillUnmount
  }, [])

  const componentWillUnmount = () => {
    lottie.destroy()
  }

  const showLottie = () => {
    lottie.destroy()
    import('./assets/loading.json').then((animationData) => {
      if (lottieNode.current) {
        lottie.loadAnimation({
          container: lottieNode.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationData
        });
      }
    })
  }

  return (
    <div className={styles.loadingMore}>
      <div className={styles.loadingCont} ref={item => { lottieNode.current = item }}></div>
      {
        props.loadingText ? <div className={styles.loadingText}>{props.loadingText}</div> : null
      }
    </div>
  )
}

export default LoadingMore